export const linkColumnToBoard = {
  success: true,
  columns: [
    {
      Header: "",
      accessor: "name",
    },
    {
      ID: 123,
      accessor: "data_123",
      Header: "Checklist Column",
      typeDictID: 1,
      sheetID: 40,
      orderBy: 1,
      isShared: false,
      canEdit: true,
      canEditHeader: true,
      canFilter: true,
      canDelete: true,
    },
    {
      ID: 124,
      accessor: "data_124",
      Header: "Text Column",
      typeDictID: 2,
      sheetID: 40,
      orderBy: 2,
      isShared: false,
      canEdit: true,
      canEditHeader: true,
      canFilter: true,
      canDelete: true,
    },
    {
      ID: 125,
      accessor: "data_125",
      Header: "Number Column",
      typeDictID: 3,
      sheetID: 40,
      orderBy: 3,
      isShared: false,
      canEdit: true,
      canEditHeader: true,
      canFilter: true,
      canDelete: true,
    },
    {
      ID: 308,
      accessor: "data_308",
      Header: "Gender",
      typeDictID: 8,
      sheetID: 40,
      orderBy: 4,
      isShared: true,
      canEdit: true,
      canEditHeader: false,
      canFilter: false,
      canDelete: true,
      extendedFieldData: {
        type: "picker",
        icon: "venus-mars fas",
        multiSelect: false,
        options: [
          {
            ID: 8,
            title: "Female",
          },
          {
            ID: 9,
            title: "Male",
          },
        ],
        entityType: "user",
        title: "Gender",
        networkAvailableFieldID: 2,
      },
    },
  ],
  isApp: false,
  userID: 2,
};
